import React from "react";
import { __ } from "services/Translator";

/**
 * Fire the app's real auth modal the exact way Header/ExitIntent do it: flip the
 * FullLayout state true, then release it so it can be re-triggered later.
 */
const pulse = (setter) => {
  if (typeof setter !== "function") {
    return;
  }
  setter(true);
  setTimeout(() => setter(false), 500);
};

/**
 * TeaserCTA — the working Sign-Up / Log-in button pair, reused everywhere.
 *
 * Wiring: pass the FullLayout props straight through (they already reach every
 * page via passableParams):
 *   setModalSignUpPropsData, setModalLoginPropsData
 * Or override with explicit callbacks: onSignUp, onLogin.
 * The CTAs are never dead — if neither is supplied the buttons simply no-op
 * rather than throwing.
 *
 * Props:
 *   setModalSignUpPropsData?  fn  open the real Sign-Up modal
 *   setModalLoginPropsData?   fn  open the real Log-in modal
 *   onSignUp?                 fn  overrides the Sign-Up handler
 *   onLogin?                  fn  overrides the Log-in handler
 *   signUpLabel?              str default "Sign Up"
 *   loginLabel?               str default "Log In"
 *   showLogin?                bool default true
 *   size?                     "md" | "lg"  default "md"
 *   align?                    "start" | "center"  default "start"
 *   className?                str
 */
const TeaserCTA = ({
  setModalSignUpPropsData,
  setModalLoginPropsData,
  onSignUp,
  onLogin,
  signUpLabel,
  loginLabel,
  showLogin = true,
  size = "md",
  align = "start",
  className = "",
}) => {
  const handleSignUp = onSignUp || (() => pulse(setModalSignUpPropsData));
  const handleLogin = onLogin || (() => pulse(setModalLoginPropsData));

  return (
    <div
      className={
        "teaser-cta" +
        ` teaser-cta--${size}` +
        ` teaser-cta--${align}` +
        (className ? ` ${className}` : "")
      }
    >
      <button
        type="button"
        className="teaser-btn teaser-btn--primary"
        onClick={handleSignUp}
      >
        {signUpLabel || __("Sign Up")}
      </button>
      {showLogin && (
        <button
          type="button"
          className="teaser-btn teaser-btn--ghost"
          onClick={handleLogin}
        >
          {loginLabel || __("Log In")}
        </button>
      )}
    </div>
  );
};

export default TeaserCTA;
